import React, { Suspense, lazy, useState } from "react";
import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import MenuBanner from "./MenuBanner";
import NavigationDrawer from "manager-panel/NavigationDrawer";
import LoadingIndicator from "components/LoadingIndicator";
import {
  VIEWER_AUDIO,
  VIEWER_EPUB,
  VIEWER_IMAGE,
  VIEWER_PDF,
  VIEWER_VIDEO,
  VIEWER_IMAGE_BOOK,
} from "media-viewer/mediaViewerRedux";
import { Box } from "@mui/material";

// Media viewers are lazy-loaded so their heavy dependencies (epubjs,
// openseadragon, pdf.js, jw-player) download only when a viewer opens,
// rather than bloating the initial bundle.
const AudioViewerDialog = lazy(() => import("media-viewer/AudioViewerDialog"));
const EpubViewerDialog = lazy(() => import("media-viewer/EpubViewerDialog"));
const ImageViewerDialog = lazy(() => import("media-viewer/ImageViewerDialog"));
const ImageBookViewerDialog = lazy(() =>
  import("media-viewer/ImageBookViewerDialog"),
);
const PdfViewerDialog = lazy(() => import("media-viewer/PdfViewerDialog"));
const VideoViewerDialog = lazy(() => import("media-viewer/VideoViewerDialog"));

const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },

  content: {
    padding: theme.spacing(6),
    height: "100%",
  },
}));

const ManagerPanel = ({ children }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { openViewer } = useSelector(state => state.mediaViewer);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box id="manager-panel" className={classes.root}>
      <MenuBanner open={!open} onClick={handleDrawerOpen} />
      <NavigationDrawer open={open} onClose={handleDrawerClose} />
      <Box id="manager-panel-content" className={classes.content}>
        {children}
      </Box>
      <Suspense fallback={<LoadingIndicator transparent />}>
        {VIEWER_AUDIO === openViewer && <AudioViewerDialog />}
        {VIEWER_EPUB === openViewer && <EpubViewerDialog />}
        {VIEWER_IMAGE === openViewer && <ImageViewerDialog />}
        {VIEWER_IMAGE_BOOK === openViewer && <ImageBookViewerDialog />}
        {VIEWER_PDF === openViewer && <PdfViewerDialog />}
        {VIEWER_VIDEO === openViewer && <VideoViewerDialog />}
      </Suspense>
    </Box>
  );
};

export default ManagerPanel;
